// StepperOnboarding.jsx
import React from 'react';

const StepperOnboarding = ({ step }) => {
  const steps = ['Antecedentes', 'Planes', 'Resumen'];

  return (
    <div className="flex justify-between items-start mb-10 w-full overflow-x-auto">
      {steps.map((label, index) => {
        const isActive = step === index;
        const isCompleted = step > index;

        return (
          <div
            key={index}
            className="flex flex-col items-center flex-1 min-w-[100px]"
          >
            <span className={`text-center mb-2 text-sm font-bold ${
              isActive || isCompleted ? 'text-green-900' : 'text-gray-400'
            }`}>
              {label}
            </span>
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300
                ${
                  isCompleted
                    ? 'bg-green-700 text-white'
                    : isActive
                    ? 'bg-green-500 text-white scale-105'
                    : 'bg-gray-300 text-gray-600'
                }`}
            >
              {index + 1}
            </div>
            {index < steps.length - 1 && (
              <div className="w-full h-px bg-gray-300 mt-4" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepperOnboarding;

